import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=19a73655&scoped=true&"
import script from "./member-list.vue?vue&type=script&lang=js&"
export * from "./member-list.vue?vue&type=script&lang=js&"
import style0 from "./member-list.vue?vue&type=style&index=0&id=19a73655&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a73655",
  null
  
)

export default component.exports